/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { Canvas } from "./Canvas";
export const CanvasResponse = core.serialization.object({
    data: Canvas,
});
